module.exports = __webpack_public_path__ + "img/vessel_visitation_9_63021.93be3ddb.jpg";